import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import {
  Alert,
  Col,
  Row,
  Spinner,
  Form,
  Button,
  Dropdown,
  ButtonGroup,
} from "react-bootstrap";
import { getOrgs } from "../../redux/organization/actions";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarConfig from "../../components/SidebarConfig";

const OrgsForEmployees = (props) => {
  const filters = [
    { num: 1, id: "codigo", desc: "Código de empleado" },
    { num: 2, id: "nombre", desc: "Nombre de empleado" },
    { num: 3, id: "centro_costo", desc: "Centro de costo" },
    { num: 4, id: "funcion", desc: "Función" },
    { num: 5, id: "puesto", desc: "Puesto" },
    { num: 6, id: "unidad_organizativa", desc: "Unidad organizativa" },
  ];

  const [show, setShow] = useState(false);
  const [filter, setFilter] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);
  const dispatch = useDispatch();
  const data = useSelector((store) => store.orgs.orgs);
  const loading = useSelector((store) => store.orgs.loading);

  useEffect(() => {
    dispatch(getOrgs(parseInt(props.match.params.type)));
  }, [dispatch, props.match.params.type]);

  const onSearch = (e) => {
    e.preventDefault();
    if (!filter.trim()) {
      return;
    }
    //props.history.push(parseInt(props.match.params.type) === 1 ? `/empleados-formal/0/Búsqueda global/${props.match.params.type}/2/${filter}` : `/empleados/0/Búsqueda global/${props.match.params.type}/2/${filter}`);
    props.history.push(
      `/empleados/0/Búsqueda global/${props.match.params.type}/2/${filter}/${tipoBusqueda.num}`
    );
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h3 className="font-weight-bold mb-0">
              ¿CUÁL INVENTARIO DE PERSONAL DESEA VER?
            </h3>
            <Form className="ml-auto" onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    onChange={(e) => setFilter(e.target.value)}
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Dropdown className="mx-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          {loading ? (
            <div className="d-flex justify-content-center mt-4">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : data.length === 0 ? (
            <Alert className="my-4" variant="info">
              Aún no hay empresas registradas para mostrar la estructura
            </Alert>
          ) : (
            <Row>
              {data.map((item) => (
                <Col md="3" className="mb-2">
                  <Link
                    style={{ height: "100px" }}
                    //to={parseInt(props.match.params.type) === 1 ? `/empleados-formal/${item.id}/${item.nombre}/${props.match.params.type}/1/00/` : `/empleados/${item.id}/${item.nombre}/${props.match.params.type}/1/00/`}
                    to={`/empleados/${item.id}/${item.nombre}/${props.match.params.type}/1/00/00`}
                    className="btn btn-primary d-flex justify-content-center align-items-center"
                  >
                    {item.nombre}
                  </Link>
                </Col>
              ))}
            </Row>
          )}
        </div>
      </div>
    </>
  );
};

export default withRouter(OrgsForEmployees);
